export default "__VITE_ASSET__3LpKyHv$__"